import { useTranslation } from 'react-i18next';
import { getLandingContent } from '@/mocks/landingData';

export default function TrustSection() {
  const { i18n } = useTranslation();
  const { trust } = getLandingContent(i18n.language);

  return (
    <section className="py-20 md:py-28 bg-white">
      <div className="px-6 md:px-10 lg:px-16">
        <p className="text-red-600 text-sm font-medium tracking-widest uppercase mb-4 md:mb-6">
          {trust.eyebrow}
        </p>
        <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-4 md:mb-6 max-w-4xl leading-tight">
          {trust.title}
        </h2>
        <p className="text-base md:text-lg text-gray-500 max-w-2xl mb-14 md:mb-20 leading-relaxed">
          {trust.subtitle}
        </p>

        <div className="grid grid-cols-1 lg:grid-cols-[minmax(0,1.05fr)_minmax(360px,0.95fr)] gap-8 md:gap-12 items-start">
          <div className="overflow-hidden rounded-lg border border-gray-100 bg-gray-50 shadow-card">
            <img
              src="/images/landing/mesutronic-building.jpg"
              alt={trust.imageAlt}
              className="w-full aspect-[800/539] object-cover"
              width={800}
              height={539}
            />
          </div>

          <div>
            <h3 className="text-2xl md:text-3xl font-bold text-gray-900 mb-5 leading-tight">
              {trust.heading}
            </h3>
            <div className="space-y-5 text-sm md:text-base text-gray-600 leading-relaxed">
              {trust.paragraphs.map((paragraph) => (
                <p key={paragraph}>{paragraph}</p>
              ))}
            </div>

            <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 mt-8">
              {trust.stats.map((item) => (
                <div key={item} className="rounded-md border border-gray-100 bg-gray-50 px-4 py-3">
                  <p className="text-sm font-semibold text-gray-900 leading-snug">{item}</p>
                </div>
              ))}
              </div>
          </div>
        </div>
      </div>
    </section>
  );
}
